import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
	theme: {
		primary: "#efbb20",
		secondary: "#efbb20",
		accent: "#efbb20",
		error: "#FF5252",
		info: "#2196F3",
		success: "#4CAF50",
		warning: "#FFC107",
	},
	customProperties: true,
	iconfont: "md",
});
